import _ from 'lodash'
import moment from "moment/moment"
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import MCErrorMsg from "../../components/_common/ErrorMsg"
import AppContainer from '../../components/_common/_containers/AppContainer'
import ContentContainer from '../../components/_common/_containers/ContentContainer/index'
import FullWidthContainer from '../../components/_common/_containers/FullWidthContainer/FullWidthContainer'
import Section from '../../components/_common/_containers/Section/index'
import ScrollMouse from '../../components/_common/_icons/ScrollMouse'
import CourseList from '../../components/_courses/CourseList/index'
import Course from '../../components/_home/Course'
import Slider from '../../components/_home/Slider'
import MCLoading from "../../components/_minha-central/Loading"
import Endpoints from "../../config/endpoints"
import { getClassTypeNameByCode } from '../../helpers/product'
import Request from "../../helpers/request-v2"
import './style.css'


const SIMULATE_GET_SESSIONS_DATA_ERROR = false


class Home extends Component {

    state = {
        banners: null,
        sectionData: null
    }


    componentDidMount() {

        const {context} = this.props
        const banners = _.get(context, 'systemConfigParameterValue.banners', [])
        const title = _.get(context, 'systemConfigParameterValue.title', '')
        const sections = _.get(context, 'systemConfigParameterValue.sections', [])
        const publicAreaEnabled = _.get(context, 'systemConfigParameterValue.publicArea', false)

        if (publicAreaEnabled === false)
            return this.props.history.push('/login/home')

        this.setState({
            banners,
            title,
            sections,
        })
        //console.log(sections, 'SEÇÔES MAP')

        if (!context.sectionsData) {

            Promise.all(sections.map(section => this.getSectionData(section)))
                .then(results => {
                    context.set({sectionsData: results})
                    new window.LazyLoad({elements_selector: ".lazy"}) // habilita lazy load de imgs
                })
                .catch(error => {
                    console.error(error)
                    this.props.context.logError(error)
                    this.setState({error})
                })
        } else {
            setTimeout(() => {
                new window.LazyLoad({elements_selector: ".lazy"}) // habilita lazy load de imgs
            }, 150)

        }


    }


    async getSectionData(_section) {

        try {


            const section = {
                ..._section,
                type: _section.showReleaseData ? 'r' : 'p',
                data: [],
                visibleFields: Object.keys(_section.visibleContentFields)
                    .filter(key => _section.visibleContentFields[key]),
            }

            const url = section.showReleaseData ?
                Endpoints.release.search : Endpoints.product.search

            const searchParams = {
                published: true,
                productType: section.contentType,
                beginIntervalDate: moment().format("YYYY-MM-DD"),
                limit: 30,
            }

            if (section.showReleaseData) {
                searchParams.shortRelease = true
                searchParams.active = true
            } else {
                searchParams.shortProduct = true
            }

            if (section.contentType === 3)
                searchParams['classType'] = section.courseType

            const req = Request.getInstance()
            const result = SIMULATE_GET_SESSIONS_DATA_ERROR ?
                await req.createGetRequest('urlinvalida') :
                await Request
                    .getInstance()
                    .createGetRequest(url, searchParams, {}, true, true)


            const sectionReleases = result.data

            if (sectionReleases) {

                section.data = sectionReleases.map(
                    release => section.showReleaseData ?
                        this.mountReleaseSection(release, section.visibleFields) :
                        this.mountProductSection(release, section.visibleFields)
                )

            }

            return section

        } catch (error) {

            this.props.context.logError(error)
            this.setState({error: 'Ocorreu um erro ao tentar obter os dados dos cursos.'})
        }

    }


    mountProductSection(obj, fieldsToShow) {
        const result = {
            code: obj.code
        }

        if (fieldsToShow.includes("name"))
            result["name"] = obj.name
        if (fieldsToShow.includes("image"))
            result["image"] = obj.mainImageUrl
        if (fieldsToShow.includes("description"))
            result["description"] = obj.summary
        if (fieldsToShow.includes("type"))
            result["type"] = obj.classType

        return result
    }


    mountReleaseSection(obj, fieldsToShow) {
        const result = {
            code: obj.code
        }


        if (fieldsToShow.includes("name"))
            result["name"] = obj.product.name
        if (fieldsToShow.includes("releaseName"))
            result["name"] = obj.name

        if (fieldsToShow.includes("image"))
            result["image"] = obj.mainImageUrl || obj.product.mainImageUrl
        if (fieldsToShow.includes("description"))
            result["description"] = obj.product.summary
        if (fieldsToShow.includes("value"))
            result["value"] = obj.price.sightValue
        if (fieldsToShow.includes("location")) {

            if (!!obj.address && !!obj.address.city && !!obj.address.state) {
                result["location"] = `${obj.address.title ? obj.address.title + ' - ' : ''} ${obj.address.city}/${obj.address.state}`
            }
        }
        if (fieldsToShow.includes("date")) {
            result["startDate"] = obj.startDate
            result["endDate"] = obj.endDate
        }
        if (fieldsToShow.includes("workload"))
            result["workload"] = obj.workload

        return result
    }


    goToCoursePage = (id, contentType) => {
        switch (contentType) {
            case 1:
                this.props.history.push(`/produto/${id}`)
                break
            case 2:
                this.props.history.push(`/servico/${id}`)
                break
            case 3:
                this.props.history.push(`/curso/${id}`)
                break
        }
    }


    render() {

        const {
            banners,
            sections,
            title,
            error,
        } = this.state

        const {context} = this.props

        const hasBanners = !!banners && banners.length !== 0
        const hasSections = !!sections && sections.length > 0
        const hasData = title || hasBanners || hasSections

        if (error)
            return <MCErrorMsg>
                {error}
            </MCErrorMsg>


        if (!context.sectionsData)
            return <MCLoading/>

        if (!hasData)
            return <h3 style={{padding: '3rem', textAlign: 'center'}}>Central ainda não está configurada.</h3>


        return (
            <AppContainer {...this.props}
                          title={title}
                          className={'nrt-home-page'}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{title} | Home </title>
                </Helmet>

                <div>
                    <div
                        className={'slider-wrapper'}
                        style={{
                            height: '30rem',
                            maxWidth: 1400
                        }}>
                        {
                            hasBanners &&
                            <Slider id={'main-slider'}>

                                {
                                    banners.map((banner, index) => (
                                        <Slider.Slide
                                            key={`slide_${index}`}
                                            imgSrc={banner.imgSrc}
                                            title={banner.title}
                                            subtitle={banner.subtitle}
                                            actionButton={{
                                                title: banner.buttonTitle || 'Clique Aqui',
                                                link: banner.link
                                            }}
                                            darkOverlay={banner.overlay === 0}
                                            lightOverlay={banner.overlay === 1}
                                            center={banner.center}
                                        />
                                    ))
                                }
                            </Slider>
                        }
                    <ScrollMouse/>
                    </div>

                    {
                        hasSections &&
                        context.sectionsData
                            .map((section, index) => (

                                    <Section
                                        key={section.id}
                                        style={{
                                            marginTop: index === 0 ? '1.5rem' : ''
                                        }}
                                    >
                                        <FullWidthContainer>
                                            <ContentContainer center>
                                                <h2 className={'section-title'}> {section.title} </h2>

                                                {
                                                    section.awaiting ?
                                                        <div style={{
                                                            height: '10rem',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            opacity: .3
                                                        }}>

                                                            <MCLoading/>
                                                        </div>

                                                        :
                                                        <CourseList>
                                                            {
                                                                section.data &&
                                                                section.data
                                                                    .sort((a, b) => {

                                                                        if (!!b.startDate) {
                                                                            const firstDate = moment(a.startDate )
                                                                            const secondDate = moment(b.startDate)

                                                                            return firstDate.isAfter(secondDate) ? 1 : -1
                                                                        }


                                                                        a.name > b.name ? 1 : -1

                                                                    })
                                                                    .map((course, index) => {

                                                                        return (
                                                                            <Course
                                                                                key={`${section.id}_${index}`}
                                                                                id={`${section.type}${course.code}`}
                                                                                imgSrc={course.image || null}
                                                                                title={course.name || null}
                                                                                description={course.description || null}
                                                                                location={course.location || null}
                                                                                type={getClassTypeNameByCode(course.type) || null}
                                                                                startDate={course.startDate || null}
                                                                                endDate={course.endDate || null}
                                                                                workload={course.workload || null}
                                                                                value={course.value || null}
                                                                                onButtonClick={this.goToCoursePage}
                                                                                contentType={section.contentType}
                                                                            />
                                                                        )
                                                                    })}
                                                        </CourseList>
                                                }
                                            </ContentContainer>
                                        </FullWidthContainer>
                                    </Section>
                                )
                            )
                    }

                </div>
            </AppContainer>
        )
    }
}


Home.propTypes = {
    context: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
}


export default Home



// WEBPACK FOOTER //
// ./src/_pages/Home/index.js